import React, {memo} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEButton, RNEText} from '../../components';
import { width, height, totalSize } from 'react-native-dimension';

interface LogoutConfirmationModalProps {
  onCancel?: () => void;
  onConfirm?: () => void;
}

function LogoutConfirmationModal(props: LogoutConfirmationModalProps) {
  // const rneStyles = useStyles();

  return (
    <View style={rneStyles.root}>
      <RNEText
        label="Are you sure you want to logout?"
        variant="header"
        align="center"
        weight="600"
        color="accent"
        style={{fontSize: totalSize(1.6), fontFamily:'Quicksand-Medium'}}
        
      />

      <View style={rneStyles.actionContainer}>
        <View style={rneStyles.buttonContainer}>
          <RNEButton
            title="Cancel"
            color="accent"
            onPress={props.onCancel}
            style={rneStyles.buttonStyle}
            variant="outlined"
          />
        </View>
        <RNEButton
          title="Logout"
          color="accent"
          onPress={props.onConfirm}
          style={rneStyles.buttonStyle}
        />
      </View>
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    maxWidth: width(50),
    padding: height(2),
    height: height(30),
    justifyContent: 'center',
  },
  actionContainer: {
    marginTop: 80,
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: width(2),
  },
  buttonStyle: {
    width: width(12),
    borderWidth: totalSize(0.1)
  },
}));

export default memo(LogoutConfirmationModal);
